import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { AssessmentDetailsTableHeader } from './utils/assessmentDetailsPageHelper';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import dayjs from 'dayjs';
import { Stack } from '@mui/material';
import { getAssessmentDetails } from '../../../../redux/features/dashboardSlice';

export default function AssessmentDetails() {
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const assessmentDetailsLoading = useSelector((state) => state.dashboard.assessmentDetails.loading);
  const assessmentDetailsData = useSelector((state) => state.dashboard.assessmentDetails.data);
  const assessmentDetailsMeta = useSelector((state) => state.dashboard.assessmentDetails.meta);

  const queryFromDate = searchParams.get('fromDate');
  const queryToDate = searchParams.get('toDate');

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const [filters, setFilters] = useState({
    fromDate: dayjs().startOf('month'),
    toDate: dayjs().endOf('month'),
  });

  const filterHelper = (value, key) => {
    if (!value || !key) return;
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const params = {
      search: tableState?.search,
      startDate: filters.fromDate,
      endDate: filters.toDate,
      page: tableState.page,
      limit: tableState.pageSize,
      sortBy: tableState.sort.field,
      sortDirection: tableState.sort.direction,
    };
    dispatch(getAssessmentDetails(params));
  }, [filters, tableState.search, tableState.page, tableState.pageSize, dispatch, tableState.sort]);

  useEffect(() => {
    filterHelper(dayjs(queryFromDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), 'fromDate');
    filterHelper(dayjs(queryToDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), 'toDate');
  }, [queryFromDate, queryToDate]);

  return (
    <GlobalWrapper title={'Assessment Details'}>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} mb={1}>
        <FromAndToDatePicker
          fromDate={filters.fromDate}
          toDate={filters.toDate}
          setFromDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'fromDate')}
          setToDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'toDate')}
          fullWidth
        />
      </Stack>

      <GlobalTable
        rowUniqueId="assessmentId"
        headers={AssessmentDetailsTableHeader}
        rows={assessmentDetailsData}
        loading={assessmentDetailsLoading}
        tableState={tableState}
        setTableState={setTableState}
        meta={assessmentDetailsMeta}
      />
    </GlobalWrapper>
  );
}
